<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 400px;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  .sub_table1{width: 400px;text-align:center;
  .canshuname{width: 100px !important;}
  .canshuvalue{width: 200px !important;}}
  .sub_table2{width: 400px;
  .first{width: 126px;}
  .el-input{width: 100px;margin: 0px 5px;}}
  .radio{font-size: 16px;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
  /deep/.hide .el-upload--picture-card {display: none;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="catid_tr" style="height: 42px;">
          <td class="td_left">
            <span v-if="isMandatory('typeid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>信息类型
          </td>
          <td class="after">
            <el-radio v-model="form.typeid" label="1"><span class="radio">供应</span></el-radio>
            <el-radio v-model="form.typeid" label="0"><span class="radio">求购</span></el-radio>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('title')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>信息标题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.title" class="input title" @blur="detection(11, 18, form.title)"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="form.level" placeholder="请选择级别" class="select level">
                <el-option v-for="item in level_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('catid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>行业分类
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.catid" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in classifydata" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('brand')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>产品品牌
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.brand" placeholder="" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('xinghao')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>型号
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.xinghao" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('guige')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>规格
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.guige" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('jiage')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>价格
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.jiage" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('jiaoyididian')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>交易地点
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.jiaoyididian" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isContentMandatory('content')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>详细说明
          </td>
          <td class="after">
            <div id="editor" style="position:relative;z-index: 1;"></div>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">
            <span v-if="isMandatory('ssgj')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属国家
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.ssgj" placeholder="请选择所属国家" class="select level" :popper-append-to-body="false">
                <el-option v-for="item in ssgj_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>产品图片
          </td>
          <td class="after">
            <el-upload
              v-if="this.$route.path === '/Kysbgl'"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :file-list="fileList1"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width=100% />
            </el-dialog>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb2')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>产品图片2
          </td>
          <td class="after">
            <el-upload
              v-if="this.$route.path === '/Kysbgl'"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic2"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess1"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic2"
              :file-list="fileList2"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess1"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width=100% />
            </el-dialog>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('introduce')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>产品简介
          </td>
          <td class="after">
            <el-form-item>
              <el-input type="textarea" v-model="form.introduce" :rows="2" class="introduce" style="font-size: 15px;"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span class="f_hid">*</span>主要参数
          </td>
          <td class="after">
            <table class="sub_table1">
              <tr style="background-color: #dfdbdb; font-family: Microsoft YaHei;font-weight: 600;">
                <td>参数名称</td>
                <td>参数值</td>
              </tr>
              <tr>
                <td><el-input v-model="form.n1" class="canshuname"></el-input></td>
                <td><el-input v-model="form.v1" class="canshuvalue"></el-input>
              </td>
              </tr>
              <tr>
                <td><el-input v-model="form.n2" class="canshuname"></el-input></td>
                <td><el-input v-model="form.v2" class="canshuvalue"></el-input>
              </td>
              </tr>
              <tr>
                <td><el-input v-model="form.n3" class="canshuname"></el-input></td>
                <td><el-input v-model="form.v3" class="canshuvalue"></el-input>
              </td>
              </tr>
              <tr>
                <td>例如：规格</td>
                <td>例如：10cm*20cm</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span class="f_hid">*</span>交易条件
          </td>
          <td class="after">
            <table class="sub_table2">
              <tr>
                <td class="first">计量单位</td>
                <td><el-input v-model="form.unit"></el-input>
              </td>
              </tr>
              <tr>
                <td class="first">产品单价</td>
                <td><el-input v-model="form.price"></el-input>元/单位
              </td>
              </tr>
              <tr>
                <td class="first">最小起订量</td>
                <td><el-input v-model="form.minamount"></el-input>单位
              </td>
              </tr>
              <tr>
                <td class="first">供货总量</td>
                <td><el-input v-model="form.amount"></el-input>单位
              </td>
              </tr>
              <tr>
                <td>发货期限</td>
                <td>自买家付款之日起<el-input v-model="form.days" style="width: 46px;"></el-input>天内发货</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="addtime_tr">
          <td class="td_left">
            <span v-if="isMandatory('company')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司名称
          </td>
          <td class="after">
            <el-input v-model="form.company" placeholder="请输入公司名称"></el-input>
          </td>
        </tr>
        <tr class="addtime_tr">
          <td class="td_left">
            <span v-if="isMandatory('addtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>发布时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.addtime" value-format="timestamp" type="datetime" placeholder="请选择添加时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
        <!-- <tr class="addtime_tr" v-if="this.$route.path === '/KysbUpdate'">
          <td class="td_left">
            <span v-if="isMandatory('edittime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>修改时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.edittime" value-format="timestamp" type="datetime" placeholder="请选择修改时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr> -->
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Kysbgl'">添加</el-button>
      <el-button type="success" @click="modification()" v-else-if="this.$route.path === '/KysbUpdate'">确定</el-button>
      <el-button type="success" @click="isPass()" v-if="this.$route.path === '/KysbLook'">通过</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Kysbgl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/KysbUpdate'">返回</el-button>
      <el-button type="danger" @click="notPass()" v-if="this.$route.path === '/KysbLook'">不通过</el-button>
      <el-button  @click="backtrackLook()" v-if="this.$route.path === '/KysbLook'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 何宽
 * 矿业设备后台添加页
 */
import {mapState} from 'vuex'
export default {
  components: {

  },
  props: ['updataID'],
  data()
  {
    return {
      url: '',
      form: {
        typeid: '',
        catid: null,
        title: '',
        level: '',
        brand: '',
        xinghao: '',
        guige: '',
        jiage: '',
        jiaoyididian: '',
        ssgj: null,
        content: '',
        thumb: '',
        thumb2: '',
        introduce: '',
        n1: '',
        v1: '',
        n2: '',
        v2: '',
        n3: '',
        v3: '',
        unit: '',
        price: '',
        minamount: '',
        amount: '',
        days: '',
        company: '',
        addtime: null,
        edittime: null,
        hits: 0
      },
      // 富文本对象
      editor: null,
      //所属分类数据
      classifydata: [],
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList1: [{url: ''}],
      fileList2: [{url: ''}],
      userorgid: null,
      examine: '',
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],
      //表名
      tabname: 'dmcn_sell_33',
      tabContentname: 'dmcn_sell_data_33',
      //fld表数据
      fldData: [],
      fldContentData: [],
      hideUploadEdit: false
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    //创建富文本编辑器
    setTimeout(() =>
    {
      let that = this
      window.public.createEditor(that)
    }, 50)
    this.fldData = await window.public.validation(this.tabname)
    this.fldContentData = await window.public.validation(this.tabContentname)
    this.isgetData()
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    this.username = userInfo.userno
    this.getUserorganise(this.username)
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 18,
        retAtt: 1,
        typeid: this.form.typeid,
        catid: this.form.catid,
        title: this.form.title,
        level: this.form.level,
        brand: this.form.brand,
        xinghao: this.form.xinghao,
        guige: this.form.guige,
        jiage: this.form.jiage,
        jiaoyididian: this.form.jiaoyididian,
        ssgj: this.form.ssgj,
        content: this.form.content,
        thumb: this.form.thumb,
        thumb2: this.form.thumb2,
        introduce: this.form.introduce,
        n1: this.form.n1,
        v1: this.form.v1,
        n2: this.form.n2,
        v2: this.form.v2,
        n3: this.form.n3,
        v3: this.form.v3,
        unit: this.form.unit,
        price: this.form.price,
        minamount: this.form.minamount,
        amount: this.form.amount,
        days: this.form.days,
        company: this.form.company,
        addtime: this.form.addtime ? (this.form.addtime / 1000) : (Date.parse(new Date()) / 1000),
        edittime: (Date.parse(new Date()) / 1000),
        hits: 0,
        examine: this.examine,
        organiseid: this.userorgid
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'add',
          _major: 11,
          _minor: 19,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
            this.$emit('removeTab')
            this.$store.commit('onIsLb', '1')
          }
        })
      })
    },
    getUserorganise(val)
    {
      let paras = {
        cmd: 'query',
        _major: 99,
        _minor: 13,
        _exp: `no = '${val}'`
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.userorgid = ret[0].organiseid
      })
    },
    //获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/KysbUpdate')
        this.getData()
      else if (this.$route.path === '/KysbLook')
        this.getData()
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 18,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.typeid = ret[0].typeid
        this.form.catid = ret[0].catid
        this.form.title = ret[0].title
        this.form.level = ret[0].level
        this.form.brand = ret[0].brand
        this.form.xinghao = ret[0].xinghao
        this.form.guige = ret[0].guige
        this.form.jiage = ret[0].jiage
        this.form.jiaoyididian = ret[0].jiaoyididian
        this.form.ssgj = ret[0].ssgj
        this.form.content = ret[0].content
        this.form.thumb = ret[0].thumb
        this.form.thumb2 = ret[0].thumb2
        this.form.introduce = ret[0].introduce
        this.form.n1 = ret[0].n1
        this.form.v1 = ret[0].v1
        this.form.n2 = ret[0].n2
        this.form.v2 = ret[0].v2
        this.form.n3 = ret[0].n3
        this.form.v3 = ret[0].v3
        this.form.unit = ret[0].unit
        this.form.price = ret[0].price
        this.form.minamount = ret[0].minamount
        this.form.amount = ret[0].amount
        this.form.days = ret[0].days
        this.form.company = ret[0].company
        this.form.addtime = ret[0].addtime * 1000
        this.form.edittime = ret[0].edittime
        this.form.hits = ret[0].hits
        this.fileList1[0].url = ret[0].thumb !== '' ? ret[0].thumb : 'static/images/moren.jpg'
        this.fileList2[0].url = ret[0].thumb2 !== '' ? ret[0].thumb2 : 'static/images/moren.jpg'
      })
      let paras1 = {
        cmd: 'query',
        _major: 11,
        _minor: 19,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras1).then((ret) =>
      {
        this.form.content = ret[0].content
        // 重新设置编辑器内容
        this.editor.txt.html(ret[0].content)
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 18,
        retAtt: 1,
        id: this.form.id,
        typeid: this.form.typeid,
        catid: this.form.catid,
        title: this.form.title,
        level: this.form.level,
        brand: this.form.brand,
        xinghao: this.form.xinghao,
        guige: this.form.guige,
        jiage: this.form.jiage,
        jiaoyididian: this.form.jiaoyididian,
        ssgj: this.form.ssgj,
        content: this.form.content,
        thumb: this.form.thumb,
        thumb2: this.form.thumb2,
        introduce: this.form.introduce,
        n1: this.form.n1,
        v1: this.form.v1,
        n2: this.form.n2,
        v2: this.form.v2,
        n3: this.form.n3,
        v3: this.form.v3,
        unit: this.form.unit,
        price: this.form.price,
        minamount: this.form.minamount,
        amount: this.form.amount,
        days: this.form.days,
        company: this.form.company,
        addtime: this.form.addtime ? (this.form.addtime / 1000) : (Date.parse(new Date()) / 1000),
        edittime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'updateAtt',
          _major: 11,
          _minor: 19,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
            this.dialogVisible = false
            this.$router.push({path: '/Kysbgl'})
            this.$store.commit('onActiveName', '1')
          }
        })
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Kysbgl'})
      this.$store.commit('onActiveName', '1')
    },
    backtrackLook()
    {
      this.$router.push({path: '/ToExamine'})
      this.$store.commit('onActiveName', '1')
    },
    //不通过
    notPass()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 18,
        retAtt: 1,
        id: this.updataID,
        examine: 4
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '该条已为不通过', type: 'error', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/ToExamine'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //通过
    isPass()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 18, _exp: `id = ${this.updataID}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.examineInfo = ret[0].examine
        let userInfo = JSON.parse(localStorage.getItem('userMsg'))
        let examine = null
        if (userInfo.role.includes(1) && this.examineInfo === 1)
          examine = 2
        else if (userInfo.role.includes(2) && this.examineInfo === 2)
          examine = 3
        else if (userInfo.role.includes(3) && this.examineInfo === 3)
          examine = 5
        else if (userInfo.role.includes(0))
          examine = 0
        this.upExamine(examine)
      })
    },
    //修改状态
    upExamine(examine)
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 18,
        retAtt: 1,
        id: this.updataID,
        examine: examine
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '审核成功', type: 'success', customClass: 'mzindex'})
          this.$router.go(-1)
        }
      })
    },
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    onSuccess1(response)
    {
      let that = this
      window.public.onSuccess1(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/KysbAdd.vue